import {
  changeLogService
} from '@/angularBridgeCode/ringbaPortal.servicesModule';
import {
  SET_CHANGE_LOGS
} from './mutationTypes';
import {
  GET_CHANGE_LOGS_BY_OBJECT,
  GET_CHANGE_LOGS_BY_USERNAME,
  GET_CHANGE_LOGS,
  CLEAR_LOGS
} from './actionTypes';

import {
  SET_ACTION_STATUS_PENDING,
  SET_ACTION_STATUS_SUCCESS,
  SET_ACTION_STATUS_ERROR } from '@/store/helpers';

const actions = {
  async [GET_CHANGE_LOGS_BY_OBJECT]({ rootState, commit }, params) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: GET_CHANGE_LOGS_BY_OBJECT });
    commit(SET_CHANGE_LOGS, []);
    try {
      var response = await changeLogService.getAccountChangelogByObject(rootState.currentAccountId, params.objectId, params.data);
      commit(SET_CHANGE_LOGS, response);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: GET_CHANGE_LOGS_BY_OBJECT });
      return this.endDateForChangeLogRequest;
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: GET_CHANGE_LOGS_BY_OBJECT, error: e });
    }
  },
  async [GET_CHANGE_LOGS_BY_USERNAME]({ rootState, commit }, params) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: GET_CHANGE_LOGS_BY_USERNAME });
    commit(SET_CHANGE_LOGS, []);
    try {
      var response = await changeLogService.getAccountChangelogByUsername(rootState.currentAccountId, params.data);
      commit(SET_CHANGE_LOGS, response);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: GET_CHANGE_LOGS_BY_USERNAME });
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: GET_CHANGE_LOGS_BY_USERNAME, error: e });
    }
  },
  async [GET_CHANGE_LOGS]({ rootState, commit }, params) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: GET_CHANGE_LOGS });
    commit(SET_CHANGE_LOGS, []);
    try {
      var response = await changeLogService.getAccountChangelog(rootState.currentAccountId, params.data);
      commit(SET_CHANGE_LOGS, response);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: GET_CHANGE_LOGS });
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: GET_CHANGE_LOGS, error: e });
    }
  },
  async [CLEAR_LOGS]({ commit }) {
    commit(SET_CHANGE_LOGS, []);
  },
};

export default actions;